import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'ms-skeleton-minigames',
    templateUrl: './skeleton-minigames.component.html',
})
export class SkeletonMinigamesComponent {
    @HostBinding('class') className = 'sk-minigames-container sk-b-rad5';
}
